var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepotingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.283,
    height: 16.911,
    viewBox: "0 0 11.283 16.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clipboard-pink",
    d: "M21.058,2.114H19.869V1.9A1.219,1.219,0,0,0,18.68.713H17.068A.716.716,0,0,0,16.328,0a.68.68,0,0,0-.713.713H14A1.219,1.219,0,0,0,12.814,1.9v.211H11.625a.936.936,0,0,0-.925.925V15.933a.959.959,0,0,0,.978.978h9.38a.889.889,0,0,0,.713-.343,1.209,1.209,0,0,0,.211-.634V3.039A.974.974,0,0,0,21.058,2.114Zm-6.844,0h4.228v1.4H14.214Zm6.341,13.4H12.1v-12h.713v.211A1.219,1.219,0,0,0,14,4.915h4.65a1.219,1.219,0,0,0,1.189-1.189V3.514h.713Z",
    transform: "translate(-10.7)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepotingIcon);
export default __webpack_public_path__ + "static/media/RepotingIcon.7900175a415d4ce6eb41fb5a1e313d7f.svg";
export { ForwardRef as ReactComponent };